export enum DeliveryDatesMutationTypes {
  SET_AVAILABLE_DAYS = 'SET_AVAILABLE_DAYS',
  SET_FILTERED_AVAILABLE_DAYS = 'SET_FILTERED_AVAILABLE_DAYS',
  SET_UNAVAILABLE_DATES = 'SET_UNAVAILABLE_DATES',
  SET_SCHEDULE_DATES = 'SET_SCHEDULE_DATES',
  SET_AVAILABLE_EXCEPTIONS = 'SET_AVAILABLE_EXCEPTIONS',
  SET_NOTIFICATION_EXCEPTIONS = 'SET_NOTIFICATION_EXCEPTIONS'
}
